import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { ChevronDown, ChevronUp } from 'lucide-react';

/** Single currency input with £ prefix + optional icon/label/sublabel */
export const CurrencyInput = ({ value, onChange, label, sublabel, icon: Icon, disabled, testId }) => (
  <div className="space-y-1">
    <div className="flex items-center gap-1.5">
      {Icon && <Icon className="h-3.5 w-3.5 text-slate-500" />}
      <Label className="text-xs text-slate-400">{label}</Label>
    </div>
    {sublabel && <p className="text-[10px] text-slate-600 -mt-0.5">{sublabel}</p>}
    <div className="relative">
      <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-500 text-sm">£</span>
      <Input
        type="number" step="0.01" min="0"
        value={value || ''} onChange={e => onChange(parseFloat(e.target.value) || 0)}
        disabled={disabled}
        className="bg-slate-900 border-slate-600 text-white h-9 text-sm pl-7 disabled:opacity-60 disabled:cursor-not-allowed"
        data-testid={testId}
      />
    </div>
  </div>
);

/** Collapsible card section with icon + title + optional badge */
export const Section = ({ title, icon: Icon, iconColor, children, badge, collapsible, defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Card className="bg-slate-800 border-slate-700">
      <CardHeader
        className={`py-3 px-4 ${collapsible ? 'cursor-pointer' : ''}`}
        onClick={() => collapsible && setOpen(!open)}
      >
        <div className="flex items-center justify-between">
          <CardTitle className="text-white text-sm flex items-center gap-2">
            {Icon && <Icon className={`h-4 w-4 ${iconColor || 'text-sky-400'}`} />}
            {title}
            {badge}
          </CardTitle>
          {collapsible && (open
            ? <ChevronUp className="h-4 w-4 text-slate-500" />
            : <ChevronDown className="h-4 w-4 text-slate-500" />)}
        </div>
      </CardHeader>
      {(!collapsible || open) && <CardContent className="px-4 pb-4 pt-0">{children}</CardContent>}
    </Card>
  );
};

/** Single label / value row inside the tax calculation sidebar */
export const CalcRow = ({ label, value, bold, negative }) => (
  <div className="flex items-center justify-between text-xs">
    <span className={`${bold ? 'text-white font-medium' : 'text-slate-400'}`}>{label}</span>
    <span className={`${bold ? 'text-white font-medium' : negative ? 'text-red-400' : 'text-slate-300'}`}>
      {negative ? '-' : ''}£{Math.abs(parseFloat(value) || 0).toLocaleString('en-GB', { minimumFractionDigits: 2 })}
    </span>
  </div>
);

export const money = (v) => `£${(parseFloat(v) || 0).toLocaleString('en-GB', { minimumFractionDigits: 2 })}`;
